/* ------------------------------------------------------------------
   Dulhansdiary - buy-two offer bar (cart drawer)

   Renders a second progress bar under the free-shipping bar showing how
   close the shopper is to the multi-item discount. Standalone on purpose:
   it watches the shipping bar for changes rather than hooking into
   cart-drawer.js, so that file stays untouched and theme updates are safe.

   Config comes from window.CartOfferConfig, set in sections/cart-drawer.liquid.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var cfg = window.CartOfferConfig || {};
  var need = parseInt(cfg.minQuantity, 10) || 0;
  if (need < 2) { return; }

  var offerEl = document.querySelector('[data-cd-offer]');
  var shipEl = document.querySelector('[data-cd-shipping]');
  if (!offerEl) { return; }

  function money(cents) {
    var cur = cfg.currency || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function plural(n, one, many) {
    return n === 1 ? one : many;
  }

  function saved(cart) {
    var total = 0;
    if (typeof cart.total_discount === 'number') { total = cart.total_discount; }
    if (!total && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        var d = cart.items[i].discounts || [];
        for (var j = 0; j < d.length; j++) { total += d[j].amount || 0; }
      }
    }
    return total;
  }

  function render(cart) {
    var count = cart.item_count || 0;

    if (count < 1) {
      offerEl.innerHTML = '';
      offerEl.hidden = true;
      return;
    }

    var remaining = need - count;
    var filled = Math.min(count, need);
    var msg;

    if (remaining > 0) {
      msg = (cfg.away || 'Add {{ n }} more {{ unit }} and take {{ pct }} off')
        .replace('{{ n }}', String(remaining))
        .replace('{{ unit }}', plural(remaining, cfg.unitOne || 'piece', cfg.unitMany || 'pieces'))
        .replace('{{ pct }}', cfg.percentLabel || '10%');
    } else {
      var amount = saved(cart);
      msg = amount > 0
        ? (cfg.unlockedWithAmount || '{{ pct }} off applied - you saved {{ amount }}')
            .replace('{{ pct }}', cfg.percentLabel || '10%')
            .replace('{{ amount }}', '<strong>' + money(amount) + '</strong>')
        : (cfg.unlocked || '{{ pct }} off applied').replace('{{ pct }}', cfg.percentLabel || '10%');
    }

    var segments = '';
    for (var s = 0; s < need; s++) {
      segments += '<span class="cd-offer__seg' + (s < filled ? ' is-on' : '') + '"></span>';
    }

    offerEl.innerHTML =
      '<p class="cd-offer__msg">' + msg + '</p>' +
      '<div class="cd-offer__track" role="progressbar" aria-valuemin="0" aria-valuemax="' + need + '" aria-valuenow="' + filled + '">' +
        segments +
      '</div>';
    offerEl.hidden = false;
  }

  var pending = false;
  function refresh() {
    if (pending) { return; }
    pending = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function () {})
      .then(function () { pending = false; });
  }

  if (shipEl && window.MutationObserver) {
    new MutationObserver(function () { refresh(); })
      .observe(shipEl, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  }

  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.cart) { render(e.detail.cart); } else { refresh(); }
  });

  refresh();
})();
